/* The Complete step on a custom site (telify-pages.html .col, .colHead, .colLine, .colDesc, .finishBy, .qs and
   .formBar, folded at 860 pixels), in the telify layer; the page around it keeps the bottom space. Colors are theme
   tokens only. */
@layer telify {
  .col {
    width: min(680px, 100%);
    margin: 0 auto;
  }

  .head {
    padding-top: 44px;
  }

  .title {
    font-family: var(--font-display);
    font-weight: 500;
    font-size: 52px;
    line-height: 1.05;
    letter-spacing: -0.015em;
  }

  .line {
    margin-top: 14px;
    font-size: 16px;
    color: var(--text-secondary);
  }

  .desc {
    margin-top: 12px;
    max-width: 58ch;
    font-size: 17px;
    line-height: 1.65;
    color: var(--text-secondary);
  }

  .finishBy {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-top: 18px;
    padding: 7px 14px;
    border: 1px solid rgba(var(--accent-rgb), 0.4);
    border-radius: 999px;
    font-size: 14px;
    color: var(--accent);
  }

  .finishBy svg {
    width: 15px;
    height: 15px;
  }

  /* The questions alone (the `fields` part), so the button follows them outside (telify-pages.html .qs, then .formBar). */
  .fields [data-part='fields'] {
    margin-top: 40px;
    padding-top: 34px;
    border-top: var(--line);
  }

  /* The form's own 24 pixel gap plus this is the mockup's 40 between the questions and the button. */
  .bar {
    display: flex;
    margin-top: 16px;
  }

  .loading {
    padding: 104px 0;
    text-align: center;
    color: var(--text-tertiary);
  }

  /* The step could not be read: the app's words, centered in the column. */
  .failed {
    width: min(560px, 100%);
    margin: 0 auto;
    padding: 96px 0 120px;
    text-align: center;
  }

  .failedTitle {
    font-family: var(--font-display);
    font-weight: 500;
    font-size: 44px;
    line-height: 1.05;
    letter-spacing: -0.015em;
  }

  .failedText {
    margin-top: 14px;
    font-size: 17px;
    line-height: 1.6;
    color: var(--text-secondary);
  }

  .failedActions {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
    margin-top: 30px;
  }

  /* web-studio-sites D12: folded at 860 pixels, on a custom site only, as every narrow rule is. */
  @media (max-width: 860px) {
    :global(:root[data-custom-site]) .head {
      padding-top: 22px;
    }

    :global(:root[data-custom-site]) .title {
      font-size: 38px;
    }

    :global(:root[data-custom-site]) .fields [data-part='fields'] {
      margin-top: 30px;
      padding-top: 26px;
    }

    :global(:root[data-custom-site]) .continue,
    :global(:root[data-custom-site]) .failedActions > * {
      width: 100%;
    }
  }
}
